export default (axios, config) => ({
  // Где вызывается: сервер.
  async list() {
    const { data } = await axios.get(
      `${config.SERVICE_DATABASE_API_URL}/managers-data`,
    );
    return data;
  },
});
